import { GetRequest, PostRequest, PutRequest } from "../../service"

const ControllerName = "BrokerRequest"

export const GetBrokerMedicalRequests = (data) =>
    GetRequest(`${ControllerName}`, data)

export const GetBrokerMedicalRequestDetails = (id) =>
    GetRequest(`${ControllerName}/get-quotation-details/${id}`)

export const GetBrokerRequestPreviousOffer = (id) =>
    GetRequest(`${ControllerName}/get-previous-offer/${id}`)


export const GetProviderQuotationResponseDetails = (id) =>
    GetRequest(`${ControllerName}/get-provider-quotation-response-details/${id}`)

export const AcceptProviderOffer = (hospitalOrderId, data) =>
    PutRequest(`${ControllerName}/accept-quotation/${hospitalOrderId}`, data)

export const RegisterOrder = (data) =>
    PostRequest(`taly/register-order`, data)


export const SubmitPostService = (hospitalRequestId, postServicesIds) =>
    PostRequest(`${ControllerName}/submit-post-service/${hospitalRequestId}`, postServicesIds)



